import React, { useContext } from "react";
import AuthContext from "../../context/AuthContext";
import { LogoutOutlined } from "@mui/icons-material";
import { useLocation } from "react-router-dom";
import imageSrc from "../../images/newLogo.jpg";
import Cookies from "js-cookie";
import { formatDate } from "../../utils/common";


const Header = () => {
  const { logout } = useContext(AuthContext);

  const user = JSON.parse(Cookies.get("userDets") || "{}");

  const location = useLocation();
  let pathName = location.pathname;

  return (
    <header className="border-b border-gray-450 bg-[#F3F4F8] text-black px-4 py-3 flex justify-between items-center">

      <img src={imageSrc} alt="ICICI Life Insurance" className="w-24 lg:w-32 w-auto rounded-md object-contain" />

      <div className="flex items-center">

        <div className="flex flex-col mr-3">
          <p>Welcome, {user?.userName} ({user?.ntID})</p>
          <p>Last Login : {formatDate(user?.lastSuccessfulLogin)} </p>
        </div>

        <button
          onClick={logout}
          className="bg-red-500 hover:bg-red-600 text-white px-2 py-2 rounded-md"
        >
          <LogoutOutlined className="w-6 h-6" />
        </button>
      </div>
    </header>
  );
};

export default Header;
